import { render } from "./CustomInputText.vue?vue&type=template&id=492f5412"
import script from "./CustomInputText.ts?vue&type=script&lang=js"
export * from "./CustomInputText.ts?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__